/**
 * Mobile menu drawer — pin header above drawer, lock page scroll (all pages).
 */
(function () {
  'use strict';

  var MOBILE_MAX = 1023;
  var HEADER_IDS = [
    'shopify-section-announcement-bar',
    'shopify-section-top-bar',
    'shopify-section-header-inline'
  ];
  var scrollLockY = 0;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    return drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('t4s-drawer--open');
  }

  function sectionHeight(id) {
    var el = document.getElementById(id);
    if (!el) return 0;
    var height = Math.round(el.getBoundingClientRect().height);
    return height > 0 ? height : Math.round(el.offsetHeight) || 0;
  }

  function isProductPage() {
    return document.body.classList.contains('template-product') || !!document.querySelector('.npp');
  }

  function updateHeaderLayout() {
    // Sticky stacking offsets are needed on product pages at all viewports;
    // drawer top offset is mobile-only.
    if (!isMobile() && !isProductPage()) return;

    var annH = sectionHeight('shopify-section-announcement-bar');
    var topH = sectionHeight('shopify-section-top-bar');
    var inlineH = sectionHeight('shopify-section-header-inline');
    var inlineTop = annH + topH;
    var total = inlineTop + inlineH;

    if (total < 80) {
      var headerInline = document.getElementById('shopify-section-header-inline');
      if (headerInline) {
        var bottom = Math.round(headerInline.getBoundingClientRect().bottom);
        if (bottom > 0) {
          total = bottom;
        }
      }
    }

    if (total < 80) {
      total = 147;
    }

    document.documentElement.style.setProperty('--mb-announcement-height', annH + 'px');
    document.documentElement.style.setProperty('--mb-header-inline-top', inlineTop + 'px');
    if (isMobile()) {
      document.documentElement.style.setProperty('--mb-drawer-top', total + 'px');
    }
  }

  function lockScroll() {
    if (document.body.classList.contains('mb-drawer-scroll-lock')) return;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('mb-drawer-scroll-lock');
    document.body.style.top = '-' + scrollLockY + 'px';
  }

  function unlockScroll() {
    if (!document.body.classList.contains('mb-drawer-scroll-lock')) return;
    document.body.classList.remove('mb-drawer-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollLockY);
  }

  function setDrawerOpenState(open) {
    var wasOpen = document.documentElement.classList.contains('is--mb-drawer-open');
    if (open === wasOpen) return;

    document.documentElement.classList.toggle('is--mb-drawer-open', open);
    if (open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  function onDrawerOpen() {
    if (!isMobile()) return;

    if (document.documentElement.classList.contains('is--mb-drawer-open')) {
      updateHeaderLayout();
      return;
    }

    updateHeaderLayout();
    setDrawerOpenState(true);
    window.requestAnimationFrame(updateHeaderLayout);
    window.setTimeout(updateHeaderLayout, 50);
    window.setTimeout(updateHeaderLayout, 200);
  }

  function onDrawerClose() {
    setDrawerOpenState(false);
  }

  function syncDrawerState(drawer) {
    if (!isMobile()) {
      if (document.documentElement.classList.contains('is--mb-drawer-open')) {
        setDrawerOpenState(false);
      }
      return;
    }

    if (isDrawerOpen(drawer)) {
      onDrawerOpen();
    } else {
      onDrawerClose();
    }
  }

  function bindDrawer() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return;

    document.querySelectorAll('[data-menu-drawer]').forEach(function (btn) {
      if (btn.dataset.mbDrawerOffsetBound === 'true') return;
      btn.dataset.mbDrawerOffsetBound = 'true';

      btn.addEventListener('click', function () {
        window.setTimeout(function () {
          syncDrawerState(drawer);
        }, 0);
        window.setTimeout(function () {
          syncDrawerState(drawer);
        }, 100);
        window.setTimeout(function () {
          syncDrawerState(drawer);
        }, 350);
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      if (btn.dataset.mbDrawerCloseBound === 'true') return;
      btn.dataset.mbDrawerCloseBound = 'true';
      btn.addEventListener('click', onDrawerClose);
    });

    if (window.jQuery_T4NT) {
      jQuery_T4NT(drawer).on('opendDrawer', function () {
        onDrawerOpen();
      });
    }

    var observer = new MutationObserver(function () {
      syncDrawerState(drawer);
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });

    syncDrawerState(drawer);
  }

  function ensureProductHeaderSticky() {
    if (!isProductPage()) return;

    if (window.T4SThemeSP && T4SThemeSP.Header && typeof T4SThemeSP.Header.stickyInit === 'function') {
      T4SThemeSP.Header.stickyInit();
    }

    document.documentElement.classList.add('t4s-hsticky__ready');
    updateHeaderLayout();
  }

  function init() {
    updateHeaderLayout();
    bindDrawer();
    ensureProductHeaderSticky();
  }

  window.addEventListener('resize', function () {
    updateHeaderLayout();
    if (!isMobile() && document.documentElement.classList.contains('is--mb-drawer-open')) {
      setDrawerOpenState(false);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    updateHeaderLayout();
    ensureProductHeaderSticky();
  });

  if (window.ResizeObserver) {
    var headerResizeObserver = new ResizeObserver(function () {
      if (isProductPage() || isMobile()) {
        updateHeaderLayout();
      }
    });

    HEADER_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) headerResizeObserver.observe(el);
    });
  }
})();

